export const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return '-';
  }
};

export const formatPercentage = (value) => {
  if (value === null || Number(value) === 0 || value === undefined) return '-';
  return `${Number(value)}%`;
};

export const formatBoolean = (value) => {
  if (value === null || value === undefined || value === 0) return 'No';
  return value ? 'Yes' : 'No';
};

export const formatFullName = (firstName, lastName) => {
  const first = firstName || '';
  const last = lastName || '';
  const fullName = `${first} ${last}`.trim();
  return fullName || '-';
};

export const formatWebsiteUrl = (url) => {
  if (!url) return '-';
  return url.replace(/^https?:\/\//, '');
};

export const getDisplayValue = (value) => {
  if (value === null || value === 0 || value === undefined || value === '') return '-';
  return String(value);
};

export const formatSupportFlow = (supportFlow) => {
  if (!supportFlow || supportFlow.length === 0) return '-';
  return supportFlow;
};
